// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bsxx","name":"styles_name__uEeWG","phone":"styles_phone__2TZ3i"};